import { NgModule  } from "@angular/core";
import {
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSortModule,
    MatBadgeModule,
    MatRadioModule,
    MatSliderModule
} from '@angular/material'
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
    imports:[
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatCardModule,
        MatDialogModule,
        MatTableModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatOptionModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonToggleModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatSortModule,
        MatBadgeModule,
        MatRadioModule,
        MatSliderModule
    ],
    exports:[
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatCardModule,
        MatDialogModule,
        MatTableModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatOptionModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonToggleModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatSortModule,
        MatBadgeModule,
        MatRadioModule,
        MatSliderModule
    ]
})


export class MaterialModule {}